export default __webpack_public_path__ + "static/media/Side-Walk.2bed21b0.svg";